/*
 * The label of a day divider, which is core's `formatDay` and nothing of its own (§8 P12): the
 * timeline, the thread pane, Activity and a search hit name a day the same way, and the one spelling
 * has to live in `core/i18n/format.ts` because core cannot import a module.
 *
 * It stays under this name for the thread pane, which calls it; anything written now takes
 * `formatDay` directly.
 */

import { formatDay } from "../../../core/i18n/format.ts"

export function dayLabel(ms: number, now: number): string {
	return formatDay(ms, now)
}
